import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class Customer extends NousCoreModel {
	description = "";
	enabled = false;
	extraData = {};
	name = "";
	apiKeyList = [];

	__selected = false;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = this.__export();

		exportData.apiKeyList = this.exportArrayField("apiKeyList");
		exportData.extraData = this.exportObjectField("extraData");
		exportData.enabled = this.exportBooleanField("enabled");

		return exportData;
	}

	import (data, options) {
		this.__import(data, options);

		this.importBooleanField("enabled", data.enabled);
	}
}

Shark.registerModel("Customer", Customer);

export default Customer;